"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AlertLink = _ref => {
  let {
    link,
    linkTo
  } = _ref;
  if (link) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: linkTo,
      title: link,
      target: "_blank",
      rel: "noreferrer"
    }, link);
  }
  return null;
};
var _default = exports.default = AlertLink;